import { Box, Button } from '@mui/material'
import { type GridColDef } from '@mui/x-data-grid'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { DataTable } from 'components/Shared/DataTable'
import { Modal } from 'components/Modal/Modal'
import { ModalFullBody } from 'components/Modal/ModalFullBody'
import { ModalFullFooter } from 'components/Modal/ModalFullFooter'
import { ModalFullHeader } from 'components/Modal/ModalFullHeader'
import { useGetAllLicensedEstablishments } from 'hooks/api/useGetAllLicensedEstablishments'
import { useLayout } from 'hooks/useLayout'

interface BadgeLocationsModalProps {
  isOpen: boolean
  licensedEstablishmentIds: number[]
  onClose: () => void
}

const columns: GridColDef[] = [
  { field: 'standardName', headerName: 'Name', minWidth: 300, flex: 1 },
  {
    field: 'licenseNumber',
    headerName: 'License Number',
    minWidth: 100,
    maxWidth: 200,
    flex: 1,
  },
]

export const BadgeLocationsModal = ({
  isOpen,
  licensedEstablishmentIds,
  onClose,
}: BadgeLocationsModalProps) => {
  const { isMobile } = useLayout()
  const { data: licensedEstablishments, isPending } =
    useGetAllLicensedEstablishments()
  const heightModal = isMobile ? '100%' : '75%'
  const selectedLocations =
    licensedEstablishments?.filter((licensedEstablishment) =>
      licensedEstablishmentIds.includes(licensedEstablishment.id)
    ) ?? []

  return (
    <Modal
      isOpen={isOpen}
      toggleIsOpen={() => {}}
      sx={{
        width: isMobile ? '100%' : '55%',
        height: heightModal,
      }}
    >
      <ModalFullHeader title="Locations" toggleIsOpen={onClose} />
      <ModalFullBody heightModal={heightModal}>
        <Box sx={{ flexGrow: 1, p: 2 }}>
          {isPending ? (
            <ActivityIndicator />
          ) : (
            <DataTable
              data-testid="badge-locations-table"
              columns={columns}
              getRowId={(row) => row.id}
              rows={selectedLocations}
              sortFieldName="standardName"
            />
          )}
        </Box>
      </ModalFullBody>
      <ModalFullFooter>
        <Button variant="text" onClick={onClose}>
          Close
        </Button>
      </ModalFullFooter>
    </Modal>
  )
}
